import type { ApiMarket } from 'api/types';

// Actions

export const loadMarkets = (
  loggedIn: boolean,
  markets: ApiMarket[],
  defaultMarket: string
) => ({
  type: 'LOAD_MARKETS' as const,
  loggedIn,
  markets,
  defaultMarket,
});

export const debugUpdateMarketsStatus = (status: ApiMarket['status']) => ({
  type: 'DEBUG_UPDATE_LISTED_MARKETS_STATUS' as const,
  status,
});

/** Use with upcoming (hidden) unlisted markets */
export const loadHiddenMarket = (market: ApiMarket) => ({
  type: 'LOAD_HIDDEN_MARKET' as const,
  market,
});
